<template>
    <v-card-title class="page-title">
        {{ $t(`text.${title}`) }} {{ info }}
    </v-card-title>
</template>

<script>
export default {
	name: 'PageSubTitle',
	props: {
		title: {
			type: String,
			required: true,
		},
		info: {
			type: String,
			default: '',
		},
	},
};
</script>

<style lang="scss" scoped>
.page-title {
    color: #e4af0c;
    font-size:18px;
    padding-left:0px!important;
}
</style>
